import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import Badge from "react-bootstrap/Badge";
import {
  FormOutlined,
  ZoomInOutlined,
  EditOutlined,
  MinusCircleOutlined,
  DownloadOutlined,
  HistoryOutlined,
  CheckOutlined
} from "@ant-design/icons";
import "./PregledTable.css";
import { Tooltip } from "antd";
import DropDown from "../UI/Dropdown/Dropdown";

const OsobeDrustvaTreceZemljeTable = (props) => {

  let registarLabel = "";
  let nazivLabel = "";
  let vrDrustva;

  if (props.formId == 7) {
    registarLabel =
      "REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I REGISTAR REVIZORA U TREĆOJ ZEMLJI";
    nazivLabel = "Subjekt / revizor";
    vrDrustva = 4;
  }

  const poruka =
    props.children && props.children.length == 0 ? (
      <div style={{ textAlign: "center", marginTop: "0px" }}>
        <p className="search-result-text">Zadana pretraga nema rezultata.</p>
      </div>
    ) : null;

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";


  let dropdownData = [
    <option key={1} value={"sve"}>
      Svi rezultati
    </option>,
    <option key={2} value={"osobe"}>
      Revizori
    </option>,
    <option key={3} value={"drustva"}>
      Subjekti
    </option>,
  ];

  return (
    <>
      {props.children && props.children.length > 0 ? (
        <div
          style={{ marginBottom: "32px", width: "200px", marginLeft: "1px" }}
        >
          <DropDown
            readOnly={false}
            hidden={true}
            onChange={(e) => props.subjektDropdownChanged(e.target.value)}
            asProperty="select"
            map={dropdownData}
            label="Filter:"
            value={props.filterDropdownValue}
            id="dropdown"
            text="Odaberite revizora ili subjekta"
          ></DropDown>
        </div>
      ) : null}
      {props.children && props.children.length != 0 ? (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginBottom: ".5rem",
          }}
        >
          <h5
            style={{
              lineHeight: "1.2",
              margin: "0 8px 0",
            }}
          >
            {registarLabel}
          </h5>

          <Tooltip title="Preuzmi registar u CSV">
            <ButtonComponent
              className="download_csv"
              onClick={(e) =>
                props.exportRegistar("drustvo", vrDrustva, registarLabel)
              }
              variant="secondary"
            >
              <DownloadOutlined />
            </ButtonComponent>{" "}
          </Tooltip>
        </div>
      ) : null}{" "}
      {poruka}
      <Table responsive bordered hover>
        <thead>
          {props.children && props.children.length != 0 ? (
            <tr className="tr_table">
              <th scope="col">{nazivLabel}</th>
              <th scope="col">Registarski broj</th>
              {props.formId != 5 ? (
                <th scope="col">OIB / Identifikacijski broj</th>
              ) : null}
              {props.formId == 5 ? <th scope="col">Država</th> : null}
              <th scope="col">Detalji</th>
              {checkIfUserIsAdmin ? (
                <Fragment>
                  <th scope="col">Povijest</th>
                  <th scope="col">Ažuriraj bez zahtjeva</th>
                  <th scope="col">Ažuriraj po zahtjevu</th>
                  <th scope="col">Akcija</th>
                  <th scope="col">Status</th>
                </Fragment>
              ) : null}
            </tr>
          ) : null}
        </thead>
        <tbody>
          {props.children &&
            props.children.map(
              (element) =>
                ((!props.isAuthenticated && element.status == "1") ||
                  (props.userRole === "ROLE_KORISNIK" &&
                    element.status == "1") ||
                  checkIfUserIsAdmin) && (
                  <tr key={element.id}>
                    <td>
                      {element.nazDrustva
                        ? element.nazDrustva
                        : element.ime + " " + element.prezime}
                    </td>
                    <td>{element.regBroj}</td>
                    {props.formId != 5 ? (
                      <td>
                        {element.tip === "osobe" && checkIfUserIsAdmin
                          ? element.oib
                            ? element.oib
                            : element.idBroj
                          : element.tip === "drustva"
                          ? element.oib
                            ? element.oib
                            : element.idBroj
                          : null}
                      </td>
                    ) : null}
                    {props.formId == 5 ? <td>{element.nazDrzave}</td> : null}
                    <td className="ant_batn">
                      <ButtonComponent
                        variant="secondary"
                        onClick={(e) =>
                          props.detaljiClicked(
                            element.tip === "drustva"
                              ? element.id
                              : element.idDrustva,
                            4,
                            "drustvo",
                            false
                          )
                        }
                      >
                        <ZoomInOutlined />
                      </ButtonComponent>
                    </td>
                    {checkIfUserIsAdmin ? (
                      <Fragment>
                        <td className="ant_batn">
                          <ButtonComponent
                            disabled={element.status === 2}
                            variant="secondary"
                            onClick={(e) =>
                              props.povijestClicked(
                                element.regBrojDrustva,
                                "drustvoTreceZemlje"
                              )
                            }
                          >
                            <HistoryOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.redirectHandler(
                                e,
                                element.tip === "drustva"
                                  ? element.id
                                  : element.idDrustva,
                                element.vr
                              )
                            }
                            disabled={
                              element.status == 2 || element.tip === "osobe"
                            }
                          >
                            <EditOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.azurirajClicked(
                                e,
                                element.tip === "drustva"
                                  ? element.id
                                  : element.idDrustva,
                                element.vr,
                                element.regBroj
                              )
                            }
                            disabled={
                              element.status == 2 || element.tip === "osobe"
                            }
                          >
                            <FormOutlined />
                          </ButtonComponent>
                        </td>
                        
                        {element.status == 2 ? (
                        <td className="aktivirajButton ant_batn">
                          <Tooltip title={element.tip != "osobe" && "Aktiviraj subjekt"}>
                          <ButtonComponent
                            onClick={(e) =>
                              props.aktivirajClicked(
                                element.tip === "drustva"
                                  ? "trecaZemljaDrustvo"
                                  : "trecaZemljaOsoba",
                                element.id,
                                element.zahtjevAtrId
                              )
                            }
                            disabled={
                               element.tip === "osobe"
                            }
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <CheckOutlined />
                          </ButtonComponent>  {" "}
                          </Tooltip>
                        </td> ) : (
                        <td className="disableButton ant_batn">
                          <Tooltip title={element.tip != "osobe" && "Deaktiviraj subjekt"}>
                          <ButtonComponent
                            onClick={(e) =>
                              props.deaktivirajClicked(
                                element.tip === "drustva"
                                  ? "trecaZemljaDrustvo"
                                  : "trecaZemljaOsoba",
                                element.id,
                                element.zahtjevAtrId
                              )
                            }
                            disabled={
                              element.tip === "osobe"
                            }
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <MinusCircleOutlined />
                          </ButtonComponent>  {" "}
                          </Tooltip>
                        </td>)}
                        <td>
                          {element.status == 1 ? (
                            <Badge pill variant="success">
                              Aktivan
                            </Badge>
                          ) : (
                            <Badge pill variant="danger">
                              Brisan
                            </Badge>
                          )}
                        </td>
                      </Fragment>
                    ) : null}
                  </tr>
                )
            )}
        </tbody>
      </Table>
    </>
  );
};

export default OsobeDrustvaTreceZemljeTable;
